import { z } from 'zod';

export const DEFAULT_POV_FONT_SIZE = 24;
export const IOS_POV_REFERENCE_FONT_SIZE = 19;
export const ANDROID_POV_REFERENCE_FONT_SIZE = 17;

const povStyleShape = z.object({
  fontSize: z.number().positive().optional().catch(undefined),
});

/** POV label style from chapter content, reduced to its font size; malformed values parse as "no size". */
export const PovStyle = povStyleShape.optional().catch(undefined);
export type PovStyle = z.infer<typeof PovStyle>;

/** POV label style from chapter content with all authored keys kept; malformed values parse as "no size". */
export const LoosePovStyle = povStyleShape.loose().optional().catch(undefined);
export type LoosePovStyle = z.infer<typeof LoosePovStyle>;

/** POV label font size for a reader font size; content without a positive POV size uses the default POV size. */
export const getPovFontSize = (
  povFontSize: unknown,
  readerFontSize: number,
  referenceReaderFontSize: number = IOS_POV_REFERENCE_FONT_SIZE,
): number => {
  const baseSize =
    typeof povFontSize === 'number' && Number.isFinite(povFontSize) && povFontSize > 0
      ? povFontSize
      : DEFAULT_POV_FONT_SIZE;
  return (baseSize * readerFontSize) / referenceReaderFontSize;
};
